import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { PurchaseMenu } from "@website/widget/common/components/purchase-menu";
import { useMyTrips } from "@website/widget/header/components/my-trips/my-trips-hook";
export function MyTrips() {
  const $ = _c(14);
  const {
    purchaseList,
    purchaseMenuIsOpen,
    onPurchaseMenuClose,
    onPurchaseMenuOpen
  } = useMyTrips();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MaterialIcon name="luggage" variant="outlined" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== onPurchaseMenuOpen) {
    t1 = <Button StartIcon={t0} className="!mx-0 max-xl:!hidden" color="neutral" onClick={onPurchaseMenuOpen} variant="text">سفرهای من</Button>;
    $[1] = onPurchaseMenuOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon name="luggage" variant="outlined" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onPurchaseMenuOpen) {
    t3 = <Button EndIcon={t2} aria-label="Show Purchase List" className="!mx-0 xl:!hidden" color="neutral" equalDimension={true} onClick={onPurchaseMenuOpen} variant="text" />;
    $[4] = onPurchaseMenuOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onPurchaseMenuClose || $[7] !== purchaseList || $[8] !== purchaseMenuIsOpen) {
    t4 = <PurchaseMenu isOpen={purchaseMenuIsOpen} list={purchaseList} onClose={onPurchaseMenuClose} />;
    $[6] = onPurchaseMenuClose;
    $[7] = purchaseList;
    $[8] = purchaseMenuIsOpen;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className="relative">{t1}{t3}{t4}</div>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}